<template>
  <div class="app">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>

    <InstallGuide
      v-if="showInstallGuide"
      class="install-overlay"
      @close="closeInstallGuide"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import InstallGuide from '@/components/InstallGuide.vue'
import { initTheme } from '@/app/theme'

declare global {
  interface ScreenOrientation {
    lock(orientation: 'portrait' | 'landscape' | 'any'): Promise<void>
  }
}

const showInstallGuide = ref(false)

function closeInstallGuide() {
  showInstallGuide.value = false
}

onMounted(() => {
  initTheme()

  const isInstalled =
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true

  showInstallGuide.value = !isInstalled
})
</script>

<style>
.app {
  min-height: 100dvh;
}

.install-overlay {
  position: fixed;
  inset: 0;
  z-index: 999999;
}
</style>